import { defineComponent as _defineComponent } from 'vue'
import {
  TransactionDirection,
  Transaction,
  isDeposit,
  isWithdraw,
  isTrade,
  HistoricalTransaction,
  transactionStateLabels,
  TransactionState,
  isPartnerPayment,
} from 'ah-api-gateways';
import TransactionDetails from 'ah-wallets/src/components/transactions/TransactionDetails.vue';
import TransactionReason from 'ah-wallets/src/components/transactions/TransactionReason.vue';
import { formatDate } from 'ah-common-lib/src/helpers/time';
import { computed } from 'vue';
import { useAhWalletsState } from '../..';
import WalletsFormattedCurrency from '../../currency/WalletsFormattedCurrency.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionsTable',
  props: {
    scheduled: { type: [Boolean, String], default: false },
    withRowDetails: { type: [Boolean, String], default: true },
    withStatusIndication: { type: [Boolean, String], default: true },
    dateFormat: null
  },
  setup(__props: any) {

const props = __props as { scheduled: boolean | string, withRowDetails: boolean | string, withStatusIndication: boolean | string, dateFormat?: string };



const walletState = useAhWalletsState();

const isScheduled = computed(() => props.scheduled !== false);

function isDebit(item: Transaction) {
  return item.direction === TransactionDirection.DEBIT;
}

function isHistorical(item: Transaction): item is HistoricalTransaction {
  return !!(item as HistoricalTransaction).state;
}

function rowClass(item: HistoricalTransaction) {
  if (props.withStatusIndication !== false) {
    if (isHistorical(item)) {
      if ([TransactionState.FAILED, TransactionState.REJECTED].includes(item.state)) return 'failed';
      else if ([TransactionState.PENDING, TransactionState.IN_REVIEW].includes(item.state)) return 'pending';
    }
  }
}

function itemHasDetails(item: Transaction) {
  return (item && (isDeposit(item) || isWithdraw(item) || (isTrade(item) && item.tradeId))) || isPartnerPayment(item);
}

function getStateLabel(item: Transaction) {
  if (item && isHistorical(item)) {
    return transactionStateLabels[item.state];
  }
}

return { __sfc: true,props, walletState, isScheduled, isDebit, isHistorical, rowClass, itemHasDetails, getStateLabel, TransactionDetails, TransactionReason, formatDate, WalletsFormattedCurrency }
}

})